var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import nem from 'nem-sdk';
import nemWrapper from './nemWrapper';
import getAccountList from './getAccountList';
import mosaicTransfer from './mosaicTransfer';
import axios from 'axios';
import helper from './helper';
var others = /** @class */ (function () {
    function others() {
        var _this = this;
        /*account data */
        this.undefined = false;
        this.lastId = '';
        /*htmlにわたす */
        this.balance = 'loading...';
        this.balance_uq = 0;
        this.sum = 'loading...';
        this.sum_uq = 0;
        this.carry_over = "loading...";
        this.carry_over_uq = 0;
        this.expiration = "loading...";
        this.expiration_uq = 0;
        this.check5day = '';
        this.recieve_data_string = [];
        this.service_years = '';
        this.email = '';
        this.company_name = '';
        this.user_name = '';
        /*others*/
        this.recieve_this_year_uq = 0;
        this.recieve_last_year_uq = 0;
        this.nowY = 'tmp';
        this.nem = new nemWrapper();
        this.nowd = new Date();
        this.recieve_data = [];
        this.getAccountList = new getAccountList();
        this.mosaicTransfer = new mosaicTransfer();
        this.helper = new helper();
        //必要な有給
        this.gimu = 4000; //5日*8時間*100
        this.mosaicTransfer.load() //アドレス取得
            .then(function () {
            _this.set_nowY(); //年度セット
            _this.getAccountMo() //残高取得  
                .then(function () {
                _this.setUserInfo(); //勤続年数セット
                _this.getTransactions(_this.mosaicTransfer.address, ''); //トランザクション取得
                //this.getTransactions("NC5PTZ47JFGJP4SHNUDOGJKDTA6RQGOZXUTCUDLW",'')
            });
        }).catch(function (error) {
            console.error(error);
        });
    }
    //年度をセット
    others.prototype.set_nowY = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.getTerm(this.nowd.getFullYear(), this.nowd.getMonth() + 1)];
                    case 1:
                        _a.nowY = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    //nemのdate取得
    others.prototype.returnd = function (timeStamp) {
        return __awaiter(this, void 0, void 0, function () {
            var NEM_EPOCH;
            return __generator(this, function (_a) {
                NEM_EPOCH = Date.UTC(2015, 2, 29, 0, 6, 25, 0);
                return [2 /*return*/, new Date(timeStamp * 1000 + NEM_EPOCH)];
            });
        });
    };
    // モザイクの残高取得
    others.prototype.getAccountMo = function () {
        return __awaiter(this, void 0, void 0, function () {
            var yourMosaicName, result, smart_uq_data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        yourMosaicName = this.mosaicTransfer.yourMosaicName;
                        return [4 /*yield*/, this.nem.getAccountMo(this.mosaicTransfer.address)
                            //let result = await this.nem.getAccountMo("NC5PTZ47JFGJP4SHNUDOGJKDTA6RQGOZXUTCUDLW")
                            /*smart-uq のデータだけ抽出*/
                        ];
                    case 1:
                        result = _a.sent();
                        smart_uq_data = result.data.filter(function (value) {
                            return value.mosaicId.name === yourMosaicName;
                        });
                        if (smart_uq_data[0] && smart_uq_data[0].quantity) {
                            this.balance_uq = smart_uq_data[0].quantity;
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    //トランザクション履歴取得
    others.prototype.getTransactions = function (address, id) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                nem.com.requests.account.transactions.all(this.nem.endpoint, address, '', id)
                    .then(function (res) {
                    console.log(res.data);
                    if (res.data.length == 0) {
                        console.log("finish getting data");
                        _this.set();
                    }
                    for (var i = 0; i < res.data.length; i++) {
                        _this.cal(res.data[i]); //計算する
                        if (i == res.data.length - 1) { //次の25件取得
                            id = res.data[i].meta.id;
                            _this.getTransactions(address, id);
                        }
                    }
                });
                return [2 /*return*/];
            });
        });
    };
    others.prototype.cal = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var flag_ThisTermSendUq, flag_kurikoshi, _a, _b, tran, signature, recipient, timestamp, amount, message;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, this.nem.checkRecieveUq(data.transaction, this.mosaicTransfer.yourMosaicName, this.mosaicTransfer.address)];
                    case 1:
                        if (!_c.sent()) return [3 /*break*/, 7];
                        return [4 /*yield*/, this.checkThisTermSendUq(data.transaction.message.payload)];
                    case 2:
                        flag_ThisTermSendUq = _c.sent();
                        return [4 /*yield*/, this.checkKurikoshi(data.transaction.message.payload)];
                    case 3:
                        flag_kurikoshi = _c.sent();
                        if (!flag_ThisTermSendUq) return [3 /*break*/, 4];
                        this.recieve_this_year_uq += parseInt(data.transaction.mosaics[0].quantity);
                        return [3 /*break*/, 6];
                    case 4:
                        if (!flag_kurikoshi) return [3 /*break*/, 6];
                        //console.log("message:"+this.nem.utf8_hex_string_to_string(data.transaction.message.payload))
                        _a = this;
                        //console.log("message:"+this.nem.utf8_hex_string_to_string(data.transaction.message.payload))
                        _b = _a.recieve_last_year_uq;
                        return [4 /*yield*/, this.getKurikoshi(data.transaction.message.payload)];
                    case 5:
                        //console.log("message:"+this.nem.utf8_hex_string_to_string(data.transaction.message.payload))
                        _a.recieve_last_year_uq = _b + _c.sent();
                        _c.label = 6;
                    case 6: return [3 /*break*/, 10];
                    case 7:
                        if (!(data.transaction.mosaics !== undefined)) return [3 /*break*/, 10];
                        if (!(data.transaction.message.payload !== undefined)) return [3 /*break*/, 10];
                        tran = data.transaction;
                        signature = tran.signer;
                        recipient = tran.recipient;
                        return [4 /*yield*/, this.nem.dispTimeStamp(tran.timeStamp)];
                    case 8:
                        timestamp = _c.sent();
                        amount = tran.amount / 1000000;
                        return [4 /*yield*/, this.nem.utf8_hex_string_to_string(tran.message.payload)];
                    case 9:
                        message = _c.sent();
                        if (message != null && message.indexOf("[[[年次有給申請]]]") !== -1 && message.indexOf("有給休暇日：" + this.nowY + "-") !== -1) {
                            this.sum_uq += amount;
                        }
                        _c.label = 10;
                    case 10: return [2 /*return*/];
                }
            });
        });
    };
    //年次支給分か判定
    others.prototype.checkThisTermSendUq = function (payload) {
        return __awaiter(this, void 0, void 0, function () {
            var a;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.nem.utf8_hex_string_to_string(payload)];
                    case 1:
                        if (!_a.sent()) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.nem.utf8_hex_string_to_string(payload)];
                    case 2:
                        a = _a.sent();
                        //return (a.indexOf("[[["+this.nowY+"年次有給休暇]]]")!==-1)
                        if (a.indexOf("[[[" + this.nowY + "年次有給休暇]]]") !== -1) {
                            return [2 /*return*/, true];
                        }
                        _a.label = 3;
                    case 3: return [2 /*return*/, false];
                }
            });
        });
    };
    //繰越か判定
    others.prototype.checkKurikoshi = function (payload) {
        return __awaiter(this, void 0, void 0, function () {
            var a;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.nem.utf8_hex_string_to_string(payload)];
                    case 1:
                        if (!_a.sent()) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.nem.utf8_hex_string_to_string(payload)];
                    case 2:
                        a = _a.sent();
                        if (a.indexOf("[[[" + (this.nowY - 1) + "年度繰越分]]]") !== -1) {
                            return [2 /*return*/, true];
                        }
                        _a.label = 3;
                    case 3: return [2 /*return*/, false];
                }
            });
        });
    };
    //繰越UQを取得
    others.prototype.getKurikoshi = function (payload) {
        return __awaiter(this, void 0, void 0, function () {
            var a;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.nem.utf8_hex_string_to_string(payload)];
                    case 1:
                        a = _a.sent();
                        a = a.replace("[[[" + (this.nowY - 1) + "年度繰越分]]] ", "");
                        a = a.replace("UQ", "");
                        return [2 /*return*/, parseInt(a)];
                }
            });
        });
    };
    //年度を返す関数
    others.prototype.getTerm = function (Y, M) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (1 <= M && M <= 3)
                    return [2 /*return*/, Y - 1];
                else
                    return [2 /*return*/, Y];
                return [2 /*return*/];
            });
        });
    };
    //最後の処理
    others.prototype.set = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                //this.sum_uq = await this.getSum()
                console.log("this.sum_uq");
                console.log(this.sum_uq);
                this.calKurikoshi();
                this.checkGimu();
                this.allUqToTime();
                this.recieveDataToArray();
                return [2 /*return*/];
            });
        });
    };
    //使用合計計算
    others.prototype.getSum = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/];
            });
        });
    };
    /*uqを時間に*/
    others.prototype.allUqToTime = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.balance = this.nem.amount_hd(this.balance_uq);
                this.sum = this.nem.amount_hd(this.sum_uq);
                this.carry_over = this.nem.amount_hd(this.carry_over_uq);
                this.expiration = this.nem.amount_hd(this.expiration_uq);
                return [2 /*return*/];
            });
        });
    };
    //有給が５日以上取得できているかを判定して、OKか、残り時間を返す
    others.prototype.checkGimu = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (this.sum_uq > this.gimu)
                    this.check5day = "５日以上有給を取得しています。";
                else
                    this.check5day = "残り" + this.nem.amount_hd(this.gimu - this.sum_uq) + "の申請が必要です。";
                return [2 /*return*/];
            });
        });
    };
    //繰越分計算
    others.prototype.calKurikoshi = function () {
        return __awaiter(this, void 0, void 0, function () {
            var a;
            return __generator(this, function (_a) {
                a = this.recieve_last_year_uq - this.sum_uq //繰越分ー今年度取得分
                ;
                console.log("今年度配布分");
                console.log(this.recieve_this_year_uq);
                console.log("昨年度配布分");
                console.log(this.recieve_last_year_uq);
                console.log(a);
                if (a >= 0) {
                    this.expiration_uq = a; //失効
                    this.carry_over_uq = this.recieve_this_year_uq; //来年度繰越可能額　＝　年次有給休暇　
                }
                else if (this.recieve_this_year_uq + a > 0) { //年次有給休暇　＋　昨年度繰越分　ー　今年度取得分 
                    this.expiration_uq = 0; //失効なし
                    this.carry_over_uq = this.recieve_this_year_uq + a; //年次有給休暇　＋　昨年度繰越分　ー　今年度取得分　＝　来年度繰越可能額
                }
                else {
                    this.expiration_uq = 0; //失効なし
                    this.carry_over_uq = 0; //繰越なし
                }
                console.log(this.recieve_data);
                return [2 /*return*/];
            });
        });
    };
    others.prototype.recieveDataToArray = function () {
        return __awaiter(this, void 0, void 0, function () {
            var i, tmp;
            return __generator(this, function (_a) {
                for (i = 0; i < this.recieve_data.length; i++) {
                    tmp = {
                        timeStamp: this.nem.dispTimeStamp(this.recieve_data[i].timeStamp),
                        uq: this.recieve_data[i].mosaics[0].quantity / 1000,
                        time: this.nem.amount_hd(this.recieve_data[i].mosaics[0].quantity / 1000),
                        message: this.nem.utf8_hex_string_to_string(this.recieve_data[i].message.payload)
                    };
                    console.log(tmp);
                    this.recieve_data_string.push(tmp);
                }
                return [2 /*return*/];
            });
        });
    };
    //勤続年数計算
    others.prototype.getUserInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log("in getuserinfo");
                        return [4 /*yield*/, this.helper.load('User-Info')];
                    case 1:
                        data = _a.sent();
                        if (!(data === null || data === "")) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.getUserInfofromAPI()];
                    case 2:
                        data = _a.sent();
                        this.helper.save('User-Info', data);
                        _a.label = 3;
                    case 3: return [2 /*return*/, data];
                }
            });
        });
    };
    /*ユーザー情報取得*/
    /*APIから */
    others.prototype.getUserInfofromAPI = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result, url, headers, access_token, uid, client, response;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.mosaicTransfer.address != "")) return [3 /*break*/, 3];
                        result = [];
                        url = this.helper.path + "auth_users/user_info/" + this.mosaicTransfer.address;
                        //let url = this.helper.path + "auth_users/user_info/NC5PTZ47JFGJP4SHNUDOGJKDTA6RQGOZXUTCUDLW"
                        console.log("in getuserinfo fromapi");
                        return [4 /*yield*/, this.helper.loadHeaders()];
                    case 1:
                        headers = _a.sent();
                        access_token = headers["access-token"];
                        uid = headers["uid"];
                        client = headers["client"];
                        return [4 /*yield*/, axios.get(url, {
                                headers: { "Content-Type": "application/json",
                                    "access-token": access_token,
                                    "uid": uid,
                                    "client": client },
                                data: {}
                            }).then(function (response) {
                                console.log('status:', response.status); // 200
                                console.log(response.data);
                                result = response.data.data;
                                // catchでエラー時の挙動を定義する
                            }).catch(function (error) {
                                if (error.response && error.response.status == "401") {
                                    console.log("please login");
                                    _this.helper.pleaseLogin();
                                }
                            })];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, result[0]];
                    case 3:
                        this.helper.pleaseLogin();
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /*変数に代入 */
    others.prototype.setUserInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            var user_info;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getUserInfo()];
                    case 1:
                        user_info = _a.sent();
                        return [4 /*yield*/, this.setVar(user_info)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /*変数に代入 */
    others.prototype.setVar = function (user_info) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (user_info == null || user_info.email == "")
                            this.helper.pleaseLogin();
                        this.email = user_info.email;
                        this.user_name = user_info.name;
                        this.company_name = user_info.company_name;
                        _a = this;
                        return [4 /*yield*/, this.getServiceYears(user_info.day, user_info.mon, user_info.year)];
                    case 1:
                        _a.service_years = _b.sent();
                        console.log(this.service_years + "this.service_years");
                        return [2 /*return*/];
                }
            });
        });
    };
    /*勤務年数計算 */
    others.prototype.getServiceYears = function (day, mon, year) {
        return __awaiter(this, void 0, void 0, function () {
            var myBirth, myMsec, myDay, DAYS_PER_MONTH, ageY, ageM, ageD;
            return __generator(this, function (_a) {
                if (day == 0) {
                    return [2 /*return*/, ""];
                }
                myBirth = new Date(year, mon - 1, day);
                myMsec = this.nowd.getTime() - myBirth.getTime();
                myDay = Math.floor(myMsec / (1000 * 60 * 60 * 24));
                DAYS_PER_MONTH = 365 / 12;
                ageY = Math.floor(myDay / 365);
                ageM = Math.floor((myDay - 365 * ageY) / DAYS_PER_MONTH);
                ageD = Math.floor((myDay - 365 * ageY - DAYS_PER_MONTH * ageM));
                return [2 /*return*/, "入社から" + ageY + "年" + ageM + "ヶ月" + ageD + "日"];
            });
        });
    };
    return others;
}());
export default others;



//////////////////
// WEBPACK FOOTER
// ./src/ts/others.ts
// module id = 665
// module chunks = 1